"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SlideComponent = exports.SliderTrack = exports.SliderContainer = exports.SliderWrapper = exports.EmptySliderMessage = exports.EmptySliderContainer = exports.ErrorMessageContainer = exports.ButtonsContainer = exports.ScrollButtonsWrapper = void 0;
const components_core_1 = require("@volkswagen-onehub/components-core");
exports.ScrollButtonsWrapper = components_core_1.styled.div `
  display: flex;
  gap: 20px;
  justify-content: space-between;
  ${(props) => props.buttonsPosition === 'bottom' ? 'margin-top: 10px;' : 'margin-bottom: 10px;'}
  width: 100%;
`;
exports.ButtonsContainer = components_core_1.styled.div ``;
exports.ErrorMessageContainer = components_core_1.styled.div `
  align-items: center;
  background-color:rgb(255, 162, 162);
  border-radius: 8px;
  border: 1px solid rgb(255, 91, 91);
  display: flex;
  flex-direction: column;
  height: 200px;
  justify-content: center;
  margin: 20px;
  width: 100%;
`;
exports.EmptySliderContainer = components_core_1.styled.div `
  align-items: center;
  background-color: #f8f8f8;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
  display: flex;
  flex-direction: column;
  height: 400px;
  justify-content: center;
  width: 400px;
`;
exports.EmptySliderMessage = components_core_1.styled.div `
  color: #666;
  font-size: 18px;
  text-align: center;
`;
exports.SliderWrapper = components_core_1.styled.div `
  overflow: hidden;
  width: 100%;
`;
exports.SliderContainer = components_core_1.styled.div `
  overflow: hidden;
`;
exports.SliderTrack = components_core_1.styled.div `
  ${(props) => {
    const { currentIndex, slideWidth, currentSlidesToShow, gap, isTransitioning } = props;
    const slideOffset = currentIndex * (slideWidth + gap);
    const totalWidth = slideWidth * currentSlidesToShow + gap * (currentSlidesToShow - 1);
    const translateX = (slideOffset / totalWidth) * 100;
    return `
      display: flex;
      gap: ${gap}px;
      transform: translateX(-${translateX}%);
      transition: ${isTransitioning ? 'transform 0.4s ease-in-out' : 'none'};
    `;
}}
`;
exports.SlideComponent = components_core_1.styled.div `
  ${(props) => `
    flex-basis: ${props.isLastSlideFullWidth ? "100%" : `calc(${100 / props.currentSlidesToShow}% - ${(props.gap * (props.currentSlidesToShow - 1)) / props.currentSlidesToShow}px)`};
    flex-shrink: 0;
  `}
`;
